import { createLoadableDictionaryReducer } from "~/app/store/loadableReducer";
import { type PriceInfo } from "~/domains/pricing/api/PriceInfo";
import { type AvailabilityInfo } from "~/domains/product/api/pna/AvailabilityInfo";

export const priceReducerData = createLoadableDictionaryReducer<PriceInfo[]>("price");
export const availabilityReducerData = createLoadableDictionaryReducer<AvailabilityInfo>("availability");

export const productsActions = {
  price: priceReducerData.actions,
  availability: availabilityReducerData.actions,
};
